import React from "react";
import PropTypes from "prop-types";
import { Card, CardBody, CardTitle, Row, Col, CardHeader } from "reactstrap";
import { Empty } from "antd";
import PieChart from "components/charts/PieChart";

SubjectWiseProgress.propTypes = {
  items: PropTypes.array,
  onClick: PropTypes.func,
  selected_subject: PropTypes.string,
};

SubjectWiseProgress.defaultProps = {
  items: [],
  selected_subject: "",
};

function SubjectWiseProgress({ items, onClick, selected_subject }) {
  let listItems = items.map((item, i) => {
    return (
      <Col
        sm="3"
        key={i}
        className={
          item.completed > 0
            ? "cursor-pointer-d mx-2 chart-item-flex"
            : "cursor-not-allowed chart-item-flex"
        }
        onClick={() => item.completed > 0 && onClick(item)}
      >
        <div
          className={
            selected_subject.toLowerCase() === item.name.toLowerCase()
              ? "chart-item-flex-sel"
              : " "
          }
        >
          <div className="text-center  pb-2 text-bold ">{item.name}</div>
          <PieChart
            data={item.data}
            labels={item.labels}
            subject={item.name.toLowerCase()}
          />
          <div className="text-center text-small my-2 ">
            * Click on chart for more details{" "}
          </div>
          <div className="text-center font-weight-bold">
            {item.completed} / {item.total} topic completed
          </div>
        </div>
      </Col>
    );
  });

  if (!listItems.length) {
    listItems = (
      <div className="my-4 py-2 d-f-c">
        {/* <span>No data found.</span> */}
        <Empty />
      </div>
    );
  }

  return <div className="chart-wrapper">{listItems}</div>;
}

export default SubjectWiseProgress;
